const PhotoSwipe = window.PhotoSwipe
const PhotoSwipeLightbox = window.PhotoSwipeLightbox

export class ProductPhotoSwipe extends HTMLElement {
  connectedCallback() {
    console.log('test: ProductPhotoSwipe')

    this.linkElements = this.querySelectorAll('[data-product-photoswipe-el="link"]')
    
    if (this.linkElements.length === 0) return

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      loop: false,
      showAnimationDuration: 500,
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 2,
      maxZoomLevel: 4,
      scaleMode: 'zoom',
      gallery: this.shadowRoot ? this.shadowRoot : this,
      children: '[data-product-photoswipe-el="link"]',
      bgOpacity: 0.9,
      arrowPrev: true,
      arrowNext: true,
      zoom: false,
      close: true,
      counter: false,
      preloadFirstSlide: true,
      closeOnVerticalDrag: true,
      tapAction: 'zoom',

      pswpModule: () => {
        return PhotoSwipe
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()

    this.linkElements.forEach((el, index) => {
      el.addEventListener('click', event => {
        event.preventDefault()

        const items = Array.from(this.linkElements).map(element => {
          const isVideo = element.dataset.type === 'video'
          const thumb = element.dataset.thumbImage || ''

          if (isVideo) {
            return {
              html: `
                <div class="pswp__video-wrapper">
                  <video autoplay loop playsinline muted>
                    <source src="${element.dataset.videoSrc}" type="video/mp4">
                  </video>
                </div>
              `,
              width: element.dataset.pswpWidth,
              height: element.dataset.pswpHeight,
              thumb,
            }
          } else {
            return {
              src: element.getAttribute('href'),
              width: parseInt(element.dataset.pswpWidth, 10),
              height: parseInt(element.dataset.pswpHeight, 10),
              thumb,
            }
          }
        })

        this.photoSwipeInstance.loadAndOpen(index, items)
      })
    })
  }

  setupPhotoSwipeListeners() {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addCloseButton()
      this.addDots()
      this.addPreviousButton()
      this.addNextButton()
    })

    this.photoSwipeInstance.on('change', () => {
      this.handleSlideChange()
    })
  }

  addPreviousButton() {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-prev',
      className:
        'pswp-Action_Arrow pswp-Action_ArrowCustom pswp-Action_Arrow-previous',
      ariaLabel: 'Previous',
      appendTo: 'wrapper',
      order: 1,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.prev()
      },
    })
  }

  addNextButton() {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-next',
      className:
        'pswp-Action_Arrow pswp-Action_ArrowCustom pswp-Action_Arrow-next',
      ariaLabel: 'Next',
      appendTo: 'wrapper',
      order: 3,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.next()
      },
    })
  }

  addCloseButton() {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close',
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  addDots() {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'dots',
      className: 'pswp-Action_Dots',
      appendTo: 'root',
      onInit: (element, pswp) => {
        const dotEls = []
        let dotEl
        let previousIndex = -1

        for (let i = 0; i < pswp.getNumItems(); i++) {
          const dotEl = document.createElement('button')
          dotEl.type = 'button'
          dotEl.className = 'pswp-Action_Dot reset'
          dotEl.setAttribute('aria-label', `Go to slide ${i + 1}`)
          
          dotEl.onclick = () => {
            pswp.goTo(i)
          }

          element.appendChild(dotEl)
          dotEls.push(dotEl)
        }

        element.addEventListener(
          'touchstart',
          e => {
            e.stopPropagation()
          },
          { passive: true },
        )

        element.addEventListener(
          'touchmove',
          e => {
            e.stopPropagation()
          },
          { passive: true },
        )

        element.addEventListener(
          'wheel',
          e => {
            e.stopPropagation()
          },
          { passive: true },
        )

        pswp.on('change', () => {
          if (previousIndex >= 0) {
            dotEls[previousIndex].setAttribute('aria-current', 'false')
          }
          dotEls[pswp.currIndex].setAttribute('aria-current', 'true')
          dotEls[pswp.currIndex].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
          })
          previousIndex = pswp.currIndex
        })
      },
    })
  }

  handleSlideChange() {
    const { pswp } = this.photoSwipeInstance
    const previousEl = document.querySelector('.pswp-Action_Arrow-previous')
    const nextEl = document.querySelector('.pswp-Action_Arrow-next')

    if (pswp && previousEl) {
      previousEl.disabled = pswp.currIndex === 0
    }

    if (pswp && nextEl) {
      nextEl.disabled = pswp.currIndex + 1 === pswp.getNumItems()
    }
  }

  get arrowSvg() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" fill="none">
        <path stroke="#005128" stroke-linecap="round" d="M7 1 1 7l6 6"></path>
      </svg>
    `
  }

  get closeSvg() {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="20" height="20" viewBox="0 0 20 20">
        <path d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"></path>
      </svg>
    `
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}